import { getUserIdentifier } from 'utils/id';
import { CVNA_ENV, CHAT_UI_SERVICE_NAME } from 'constants/carvana';
import { EXPERIMENT_HANDRAISER_STC } from 'constants/experiments';

export const getExperimentConfig = () => {
  const bcidIdentifier = getUserIdentifier().browserCookieId || getUserIdentifier().carvanaDeviceId;
  return {
    environment: CVNA_ENV,
    projectName: CHAT_UI_SERVICE_NAME,
    identifier: {
      [EXPERIMENT_HANDRAISER_STC.name]: bcidIdentifier,
    },
  };
};
